<template>
  <section class="BAddCart">
    <div>
      <div class="left">
        <i />
        <!-- Today's order is expected to be shipped on October 30th -->
      </div>
      <div class="right">
        <span class="price"> USD ${{ cartState.goodsTotalPrice }} </span>
        <span class="addCart" @click="goContact"> Find a Dealer </span>
        <span class="addCart" @click="toCart"> Add to Cart </span>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useCookies } from "@vueuse/integrations/useCookies";

const cookies = useCookies(["sails.sid"]);
const route = useRoute();

import { useCartStore } from "@/stores";
const { cartState, setGoodsTotalPrice } = useCartStore();

import Event from "@/stores";

const toCart = () => {
  logInfo("sails.sid", cookies.get("sails.sid"));
  if (cookies.get("sails.sid")) {
    Event.emit("addCart", "商品详情页底部-加入购物车");
  } else {
    navigateTo(`/login?redirect=${route.path}`);
  }
};

const goContact = () => {
  window.open("https://www.greenvalleyintl.com/contactNew", "_blank");
};
</script>

<style lang="less" scoped>
.BAddCart {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  // min-width: 1374px;
  height: 96px;
  background-color: #2b2b2b;
  color: #fff;

  > div {
    height: 100%;
    max-width: 1374px;
    // max-width: 1600px;
    margin: 0 auto;

    .flex(row,space-between,center);
    .left {
      .flexct();
      .fcf(18,#fff);
      i {
        display: inline-block;
        background-image: url("@/assets/imgs/product/cart.png");
        background-repeat: no-repeat;
        background-size: 100%;
        margin-right: 15px;
        .wh(22px,16px);
      }
    }
    .right {
      .flexct();
      .price {
        .fcf(28,#fff,600);
      }
      .addCart {
        display: inline-block;
        background: linear-gradient(40deg, #0189be 0%, #32a395 100%);
        border-radius: 10px;
        width: 148px;
        height: 53px;
        text-align: center;
        margin-left: 23px;
        cursor: pointer;
        .lh(53);
      }
    }
  }
}

@media (max-width: 1024px) {
  .BAddCart {
    > div {
      .right {
        .price {
          font-size: 18px;
        }
        .addCart {
          font-size: 14px;
        }
      }
    }
  }
}
</style>
